import { Card, CardBody, Col } from "reactstrap";
import { MapContainer, TileLayer } from "react-leaflet";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { LeafletAustraliaMap } from "../../../../Constant";
import { AUSTRALIA_MAP, AUSTRALIA_POSITION } from "../../../../Data/Maps";

const AustraliaMap = () => {
  return (
    <Col sm="6">
      <Card>
        <CommonCardHeader title={LeafletAustraliaMap} span={AUSTRALIA_MAP}/>
        <CardBody>
          <MapContainer className="jvector-map-height z-0" style={{ height: 389 }} zoom={4} center={AUSTRALIA_POSITION} zoomControl={true} doubleClickZoom={true} scrollWheelZoom={false} dragging={true}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          </MapContainer>
        </CardBody>
      </Card>
    </Col>
  );
};
export default AustraliaMap;
